import { Flex } from '../../../summary/components/Flex.tsx';
import { Typography } from '../../../summary/components/Typography.tsx';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { AdjustmentBreakdownDepreciatedCostMainDwellingBath } from './AdjustmentBreakdownDepreciatedCostMainDwellingBath.tsx';
import { AdjustmentBreakdownDepreciatedCostMainDwellingCondition } from './AdjustmentBreakdownDepreciatedCostMainDwellingCondition.tsx';
import { AdjustmentBreakdownDepreciatedCostMainDwellingFunctionalUtility } from './AdjustmentBreakdownDepreciatedCostMainDwellingFunctionalUtility.tsx';
import { AdjustmentBreakdownDepreciatedCostMainDwellingGLA } from './AdjustmentBreakdownDepreciatedCostMainDwellingGLA.tsx';
import { AdjustmentBreakdownDepreciatedCostMainDwellingQuality } from './AdjustmentBreakdownDepreciatedCostMainDwellingQuality.tsx';

export const AdjustmentBreakdownDepreciatedCostMainDwelling = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <SummarySection>
    <TitleAndExportToggleLockup
      {...props}
      title="Main Dwelling"
      id="isDepreciatedCostMainDwellingInExport"
      variant="h2"
    />
    <Flex marginBottom="2rem">
      <Typography variant="body1">
        For main dwelling adjustments, the difference in depreciated cost between the subject and
        each comparable was allocated to GLA, baths, condition and quality.
      </Typography>
    </Flex>
    <AdjustmentBreakdownDepreciatedCostMainDwellingGLA {...props} />
    <AdjustmentBreakdownDepreciatedCostMainDwellingBath {...props} />
    <AdjustmentBreakdownDepreciatedCostMainDwellingCondition {...props} />
    <AdjustmentBreakdownDepreciatedCostMainDwellingQuality {...props} />
    <AdjustmentBreakdownDepreciatedCostMainDwellingFunctionalUtility {...props} />
  </SummarySection>
);
